(() => {
  window.swinger.eventHub.register('click', '[data-play]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const itemNumber = elem.getAttribute('data-play');

    window.swinger.eventHub.trigger(document, 'swinger-video-player:play', itemNumber);
  });
})();
